import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { Controller, useFormContext } from 'react-hook-form';
import {
  DatePickerTime,
  DatePickerTimeProps,
} from 'shared/mui/DatePicker/components/DatePickerTime/DatePickerTime';

type Props = Pick<DatePickerTimeProps, 'label' | 'disabled'> & {
  name: string;
};

export const GatewaysEditPilotSettingsTimePicker = ({
  name,
  ...pickerProps
}: Props): JSX.Element => {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState: { error } }) => (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePickerTime
            {...pickerProps}
            inputRef={field.ref}
            onChange={field.onChange}
            slotProps={{
              textField: { helperText: error?.message, onBlur: field.onBlur },
            }}
            sx={{ width: '100%', mb: 3 }}
            value={field.value}
          />
        </LocalizationProvider>
      )}
    />
  );
};
